const turnstileErrorPatterns = [
    /turnstile/i,
    /cf-turnstile/i,
    /challenges\.cloudflare\.com/i
];

const getErrorText = (error) => {
    if (!error) return "";
    if (typeof error === "string") return error;

    let parts = [];

    if (error.message) parts.push(error.message);
    if (error.stack) parts.push(getTurnstileStackText(error.stack));
    if (error.filename) parts.push(error.filename);
    if (error.source) parts.push(error.source);
    if (error.error) parts.push(getErrorText(error.error));

    return parts.join(" ");
};

const getTurnstileStackText = (stack) => {
    return stack
        .split("\n")
        .filter(line => /cf-turnstile|challenges\.cloudflare\.com/i.test(line))
        .join(" ");
};

const getRavenFrameText = (data) => {
    if (!data || !data.exception || !data.exception.values) return "";

    return data.exception.values
        .map(value => {
            let parts = [value.type, value.value];

            if (value.stacktrace && value.stacktrace.frames) {
                parts = parts.concat(value.stacktrace.frames.map(frame => frame.filename || frame.abs_path || frame.module || ""));
            }

            return parts.join(" ");
        })
        .join(" ");
};

const matchesTurnstile = (text) => {
    return turnstileErrorPatterns.some(pattern => pattern.test(text));
};

export const isTurnstileError = (error) => {
    return matchesTurnstile(getErrorText(error));
};

export const isTurnstileRavenEvent = (data) => {
    if (!data) return false;

    return matchesTurnstile([
        data.message,
        data.culprit,
        data.request && data.request.url,
        data.transaction,
        data.logger,
        getRavenFrameText(data)
    ].filter(Boolean).join(" "));
};
